"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "children", "left", "right"];
var _default = exports["default"] = function _default(_ref) {
  var className = _ref.className,
    children = _ref.children,
    left = _ref.left,
    right = _ref.right,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, props, {
    className: "flex h-full"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-10vw p-5 text-center"
  }, left), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-1 py-5', className)
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-10vw p-5 text-center"
  }, right));
};
//# sourceMappingURL=Container.js.map